import React, {useEffect, useMemo, useState} from 'react'
import {
    Autocomplete,
    Button,
    Dialog,
    DownloadIcon,
    FilterRemoveIcon,
    FolderNewIcon,
    Heading,
    IconButton,
    InfoSignIcon,
    Link, Pagination,
    Pane,
    Paragraph,
    RemoveIcon,
    SearchInput, Select,
    SortDescIcon,
    SortIcon,
    Table,
    toaster,
    Tooltip,
    UpdatedIcon
} from "evergreen-ui";
import {useSelector} from "react-redux";
import {deleteMaterialById, getAll, getFileById, getFileByMaterialIdAndVersion, getReport} from "./Api";
import {getArchiveElementsRights} from "../Privileges/PrivilegesSelectors";
import SuspenseSpinner from "../../Utils/SuspenseSpinner";
import UploadFileDialog from "./dialogs/UploadFileDialog";
import MaterialVersionsDialog from "./dialogs/MaterialVersionsDialog";
import {selectorStationsForFilters} from "../Constructor/periodValuesFilterApi";
import UploadNewVersionDialog from "./dialogs/UploadNewVersionDialog";
import {getFileNameFromContentDisposition} from "../Constructor/common/ApiCommon";
import {AutoCompleteMaterials} from "../BaseMaterials/BaseMaterials";

export default function MaterialsTable() {

    const [isDownloadWindowShown, setIsDownloadWindowShown] = React.useState(false)
    const [newVersionWindow, setNewVersionWindow] = React.useState(false)
    const [showVersions, setShowVersions] = React.useState(false)

    const setShownCallback = (shown) => setIsDownloadWindowShown(shown)
    const onCloseActionCallback = () => setShouldUpdate(!shouldUpdate)

    const setVersionsShownCallback = (shown) => setShowVersions(shown)

    const stations = useSelector(selectorStationsForFilters);

    const [materialsId, setMaterialsId] = React.useState("")

    const [removeDialog, setRemoveDialog] = React.useState(false)

    const [materialsWithVersions, setMaterialsWithVersions] = React.useState([])
    const [elementsPerPage, setElementsPerPage] = React.useState(10)

    const setMaterialWithVersionsCallback = (material) => setMaterialsWithVersions(material)

    const [materials, setMaterials] = useState([])
    const [shouldUpdate, setShouldUpdate] = useState(true)
    const [isFetch, setIsFetch] = useState(false)
    const [curPage, setCurPage] = React.useState(1)
    const [totalPages, setTotalPages] = React.useState(0)

    const privileges = useSelector(state => state.login.privileges)

    const rights = getArchiveElementsRights(privileges)

    function changeElementsPerPage(number) {
        setCurPage(1)
        setElementsPerPage(number)
        setShouldUpdate(!shouldUpdate)
    }

    function getFilters() {
        let filters = new Map();
        if (documentNameFilter.length !== 0) {
            filters.set('name', documentNameFilter)
        }
        if (stationFilter.length !== 0) {
            filters.set('stn', stationFilter)
        }

        filters.set('elsPerPage', elementsPerPage)
        filters.set('pageNum', (curPage - 1))

        return filters
    }

    useEffect(() => {
            setIsFetch(true)
            const filters = getFilters();
            setLastRequestFilters(filters)
            getAll(filters, lastSort, lastOrder).then(res => {
                setMaterials(res.data.content)
                setCurPage(res.data.pageable.pageNumber + 1)
                setTotalPages(res.data.totalPages)
                setIsFetch(false)
            })
            setIsFetch(false)
        },
        [shouldUpdate])

    const lastSortEnum = {
        NAME: "NAME",
        STATION: "STATION",
        YEAR: "YEAR",
        UPLOAD_DATE: "UPLOAD_DATE",
        VERSION: "VERSION",
        AUTHOR: "AUTHOR",
        NOTES: "NOTES"
    }

    const [lastSort, setLastSort] = React.useState(lastSortEnum.UPLOAD_DATE)
    const [lastOrder, setLastOrder] = React.useState(false)

    const [resortStationName, setResortStationName] = React.useState(true)
    const [resortName, setResortName] = React.useState(true)
    const [resortYear, setResortYear] = React.useState(true)
    const [resortVersion, setResortVersion] = React.useState(true)
    const [resortAuthor, setResortAuthor] = React.useState(true)
    const [resortNotes, setResortNotes] = React.useState(true)
    const [resortUploadDate, setResortUploadDate] = React.useState(false)

    const [lastRequestFilters, setLastRequestFilters] = React.useState(new Map())


    useMemo(() => {
        setShouldUpdate(!shouldUpdate)
    }, [materialsWithVersions])

    function sort(asc, sort) {
        setLastOrder(asc)
        setLastSort(sort)

        getAll(lastRequestFilters, sort, asc).then(res => {
            setMaterials(res.data.content)
            setCurPage(res.data.pageable.pageNumber + 1)
            setTotalPages(res.data.totalPages)
            setIsFetch(false)
        })
    }

    useMemo(() => {
        switch (lastSort) {
            case lastSortEnum.NAME:
                sort(resortName, lastSortEnum.NAME)
                break
            case lastSortEnum.STATION:
                sort(resortStationName, lastSortEnum.STATION)
                break
            case lastSortEnum.YEAR:
                sort(resortYear, lastSortEnum.YEAR)
                break
            case lastSortEnum.UPLOAD_DATE:
                sort(resortUploadDate, lastSortEnum.UPLOAD_DATE)
                break
            case lastSortEnum.VERSION:
                sort(resortVersion, lastSortEnum.VERSION)
                break
            case lastSortEnum.AUTHOR:
                sort(resortAuthor, lastSortEnum.AUTHOR)
                break
            case lastSortEnum.NOTES:
                sort(resortNotes, lastSortEnum.NOTES)
                break
        }
    }, [resortUploadDate, resortStationName, resortYear, resortName, resortAuthor, resortVersion, resortNotes])

    function onShowVersionsButton(materialsId) {
        getFileById(materialsId).then(
            (res) => {
                setMaterialsWithVersions(res.data)
                setShowVersions(true)
            }
        )
    }

    function onFilterPress(e)  {
        if (e.key === 'Enter') {
            setCurPage(1)
            setShouldUpdate(!shouldUpdate)
        }
    }

    function changePage(page) {
        setCurPage(page)
        setShouldUpdate(!shouldUpdate)
    }

    function onDownloadButton(materialsId, filename, version) {
        const newVersion = version === undefined ? '' : version

        getFileByMaterialIdAndVersion(materialsId, newVersion).then((response) => {
            const filename = getFileNameFromContentDisposition(response.headers['content-disposition'])
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            toaster.success('Успешно загрузили!')
            setShouldUpdate(!shouldUpdate)
        });
    }

    function onGetReportButton() {
        getReport().then( (response) => {
            let filename = getFileNameFromContentDisposition(response.headers['content-disposition'])
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            toaster.success('Успешно создали!')
        })
    }


    function clearFilter() {
        setDocumentNameFilter('')
        setStationFilter('')
        setCurPage(1)
        setShouldUpdate(!shouldUpdate)
    }

    const [documentNameFilter, setDocumentNameFilter] = React.useState("")
    const [stationFilter, setStationFilter] = React.useState("")

    return (
        <Pane margin={40} height={320 +  materials.length * 40}>
            <Pane>
                <Heading size={600}>Архив материалов наблюдений</Heading>
            </Pane>
            <Pane
                display="flex"
                gridTemplateRows="max-content max-content"
                marginTop={10}
                marginBottom={20}
                gap={12}
                gridRowGap=".5em"
                alignItems="center"
            >
                <SearchInput
                    placeholder="Название документа"
                    value={documentNameFilter}
                    onKeyPress={(e) => onFilterPress(e)}
                    onChange = {(e) => setDocumentNameFilter(e.target.value)}
                />
                <Pane>
                    {AutoCompleteMaterials(setStationFilter, stations, stationFilter, onFilterPress)}
                </Pane>


                <Tooltip content="Обновить">
                    <IconButton
                        icon={UpdatedIcon}
                        onClick={() => {
                            setShouldUpdate(!shouldUpdate)
                        }}

                    />
                </Tooltip>
                <Tooltip content="Сбросить">
                    <IconButton icon={FilterRemoveIcon} onClick={() => clearFilter()}/>
                </Tooltip>
            </Pane>


            <Dialog
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEscapePress={false}
                width={700}
                intent="danger"
                onConfirm={() => deleteMaterialById(materialsId).then((res) => {
                    toaster.success("Успешно удалено!")
                    setRemoveDialog(false)
                    setShouldUpdate(!shouldUpdate)
                })}
                onCancel={() => setRemoveDialog(false)}
                isShown={removeDialog}
                title="Удалить материал наблюдения"
                cancelLabel="Отмена"
                confirmLabel="Да"
            >
                <Pane>
                    <Paragraph>Все версии файла будут удалены. Продолжить?</Paragraph>
                </Pane>
            </Dialog>

            <UploadNewVersionDialog isShown={newVersionWindow}
                                    setIsShown={(val) => setNewVersionWindow(val)}
                                    materialsId={materialsId}
                                    onVersionUpdatedAction={() => setShouldUpdate(!shouldUpdate)} />


            <UploadFileDialog setIsShown={setShownCallback} isShown={isDownloadWindowShown} onCloseAction={onCloseActionCallback}/>
            <MaterialVersionsDialog setIsShown={setVersionsShownCallback}
                                    isShown={showVersions}
                                    versions={materialsWithVersions}
                                    setVersions={setMaterialWithVersionsCallback}
                                    onClose={onCloseActionCallback}
            />

            <Pane>
                {
                    <Pane display={"flex"} columnGap={10}>
                        {rights.canUpload ? <Button onClick={() => setIsDownloadWindowShown(true)}>Загрузить</Button> : <></>}
                        {rights.canFormReport ? <Button onClick={() => onGetReportButton()}>Сформировать отчет</Button> : <></> }
                    </Pane>

                }

                { isFetch? <SuspenseSpinner/> : <Table marginTop={8}>
                    <Table.Head>
                        <Table.TextHeaderCell onClick={() => {setResortName(!resortName); setLastSort(lastSortEnum.NAME)}} isSelectable rightView={resortName ? <SortIcon/> : <SortDescIcon/>}>
                            Название документа
                        </Table.TextHeaderCell>
                        <Table.TextHeaderCell onClick={() => {setResortStationName(!resortStationName); setLastSort(lastSortEnum.STATION)}} isSelectable rightView={resortStationName ? <SortIcon/> : <SortDescIcon/>}>
                            Станция
                        </Table.TextHeaderCell>
                        <Table.TextHeaderCell onClick={() => {setResortAuthor(!resortAuthor); setLastSort(lastSortEnum.AUTHOR)}} isSelectable rightView={resortAuthor ? <SortIcon/> : <SortDescIcon/>}>Автор</Table.TextHeaderCell>
                        <Table.TextHeaderCell onClick={() => {setResortYear(!resortYear); setLastSort(lastSortEnum.YEAR)}} isSelectable rightView={resortYear ? <SortIcon/> : <SortDescIcon/>}>
                            Год
                        </Table.TextHeaderCell>
                        <Table.TextHeaderCell onClick={() => {setResortVersion(!resortVersion); setLastSort(lastSortEnum.VERSION)}} isSelectable rightView={resortVersion ? <SortIcon/> : <SortDescIcon/>}>Версия</Table.TextHeaderCell>
                        <Table.TextHeaderCell onClick={() => {setResortUploadDate(!resortUploadDate); setLastSort(lastSortEnum.UPLOAD_DATE)}} isSelectable rightView={resortUploadDate ? <SortIcon/> : <SortDescIcon/> }>Дата загрузки</Table.TextHeaderCell>
                        <Table.TextHeaderCell onClick={() => {setResortNotes(!resortNotes); setLastSort(lastSortEnum.NOTES)}} isSelectable rightView={resortNotes ? <SortIcon/> : <SortDescIcon/>}>Заметки</Table.TextHeaderCell>
                        <Table.TextHeaderCell flexBasis={90}>Меню</Table.TextHeaderCell>
                    </Table.Head>
                    <Table.VirtualBody height={materials.length * 40}>
                        {materials.map((material) => <Table.Row height={40}>
                            <Table.TextCell>{material.name}</Table.TextCell>
                            <Table.TextCell>{material.station.name}</Table.TextCell>
                            <Table.TextCell>{material.files[0].author}</Table.TextCell>
                            <Table.TextCell>{material.year}</Table.TextCell>
                            <Table.TextCell><Link cursor={"pointer"} onClick={() => {
                                onShowVersionsButton(material.materialsId)
                            }}> {material.files[0].version}</Link></Table.TextCell>
                            <Table.TextCell>{material.files[0].createDate}</Table.TextCell>
                            <Table.TextCell>{material.files[0].notes}</Table.TextCell>
                            <Table.Cell gap={5} flexBasis={90}>
                                <Tooltip content="Посмотреть версии">
                                    <IconButton marginRight={5} icon={InfoSignIcon} onClick={() => {
                                        onShowVersionsButton(material.materialsId)
                                    }}/>
                                </Tooltip>
                                {
                                    rights.canUploadNewVersion ?
                                        <Tooltip content="Загрузить новую версию">
                                            <IconButton icon={FolderNewIcon} onClick={() => {
                                                setNewVersionWindow(true)
                                                setMaterialsId(material.materialsId)
                                            }}/>
                                        </Tooltip>
                                    : <></>
                                }
                                {
                                    rights.canDownload ?
                                        <Tooltip content="Скачать">
                                            <IconButton icon={DownloadIcon} onClick={() => onDownloadButton(material.materialsId, material.name, material.files[0].version)}/>
                                        </Tooltip>
                                    : <></>
                                }
                                {
                                    rights.canRemove ?
                                        <Tooltip content="Удалить">
                                            <IconButton marginLeft={5} icon={RemoveIcon} onClick={() => {
                                                setMaterialsId(material.materialsId)
                                                setRemoveDialog(true)
                                            }}/>
                                        </Tooltip>
                                    : <></>
                                }
                            </Table.Cell>
                        </Table.Row>)}
                    </Table.VirtualBody>
                </Table> }
            </Pane>

            <Pane display={"flex"} alignItems={"center"} justifyContent={"center"} margin={10}>
                <Pagination page={curPage}
                            totalPages={totalPages}
                            onPageChange={(page) => changePage(page)}
                            onNextPage={() => changePage(curPage + 1)}
                            onPreviousPage={() => changePage(curPage - 1)}
                />
            </Pane>
            <Pane justifyContent={"right"} verticalAlign={"right"} display={"flex"} marginRight={40} marginTop={-37}>
                <Paragraph>Показывать по</Paragraph>
                <Pane>
                    <Select value={elementsPerPage} onChange={event => changeElementsPerPage(event.target.value)} marginLeft={10}>
                        <option value={"5"}>5</option>
                        <option value={"10"}>10</option>
                        <option value={"15"}>15</option>
                        <option value={"20"}>20</option>
                    </Select>
                </Pane>

            </Pane>

        </Pane>
    );
}